
import React, { useState } from 'react'
import CreditTable from './components/CreditTable'
import Header from './components/Header'
// import Header from './components/Header'
import { CreditContext } from './context'

function Credits() {
    const [displaySingleCredit, setDisplaySingleCredit] = useState(true)
    const [singleCreditsData, setSingleCreditsData] = useState(true)

    return (
        <CreditContext.Provider value={{ displaySingleCredit, setDisplaySingleCredit, singleCreditsData, setSingleCreditsData }}>
            <Header />

            <CreditTable />
        </CreditContext.Provider>
    )
}

export default Credits